import { useSelector } from 'react-redux';
import { JOB_TITLE_VALUES } from '../../../../shared/utils/constants';

export default function useIsDriver() {
  return useSelector((state) => state.settings.user.jobtitle.title === JOB_TITLE_VALUES.driver);
}
